/**
 * @brief   Singleton de AppAjax.
 * @see     resources/js/scripts/functions/AppAjax.class.js
 */
require('./functions/AppAjax.class');
let AppAjax = window.AppAjax;

/*
|--------------------------------------------------------------------------
| DEBUT DU FICHIER - NE RIEN AJOUTER D'AUTRE QUE require() AU DESSUS !
|--------------------------------------------------------------------------
*/

/**
 * @brief   Fonctionnalités de la page d'accueil'
 */
jQuery(document).ready(function() {
    // Exécution du code uniquement si l'élément du DOM existe
    if (jQuery('section[class^=section-login]').html() !== undefined) {
        // Méthodes JavaScript communes
        require('./functions/validators.functions');
        /** DEBUT DU CODE JAVASCRIPT EN DESSOUS DE CETTE PARTIE ! */

        // Force l'utilisateur à actualiser la page au bout de 60sec d'inactivité
        window.inactivityTimeout(function() {
            let label;
            let location = '/';
            if (window.lang === 'fr') {
                label = "Actualiser";
            } else {
                label = "Refresh";
                location += window.lang;
            }
            $('form#login').html('<div class="col-lg-12 text-center login-btn"><a href="' + location + '" class="btn btn-primary text-white no-submit">' + label + '</a></div>');
        }, 60000);

        /** FIN DU CODE JAVASCRIPT AU DESSUS DE CETTE PARTIE ! */
    }
});
/*
|--------------------------------------------------------------------------
| FIN DU FICHIER - NE RIEN AJOUTER EN DESSOUS !
|--------------------------------------------------------------------------
*/
